// extracted by mini-css-extract-plugin
export default {"section3":"section3_section3__fTQwn","flex_col":"section3_flex_col__9jmF5","image":"section3_image__svA7u"};